export default "__VITE_ASSET__Bn61XMwf__"